import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div
      className="min-h-screen flex items-center justify-center bg-slate-950 px-6"
      style={{ fontFamily: "'DM Sans', sans-serif" }}
    >
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');`}</style>
      <div className="text-center max-w-md">
        <div className="w-16 h-16 bg-orange-500/10 rounded-2xl flex items-center justify-center text-3xl mx-auto mb-5">
          🔍
        </div>
        <h1
          className="text-white text-2xl font-bold mb-2"
          style={{ fontFamily: "'Sora', sans-serif" }}
        >
          Page Not Found
        </h1>
        <p className="text-slate-400 text-sm mb-8 leading-relaxed">
          The page you're looking for doesn't exist or may have been moved.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 py-3 rounded-xl text-sm transition-colors"
        >
          ← Back to Home
        </Link>
      </div>
    </div>
  );
}